import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Footer from "./components/Footer";
import Breadcrumb from "./components/Breadcrumb";
import ScrollToTop from "./components/ScrollToTop";
import BreadCrumbImage from "./assets/images/branding/breadcrumbimagelight.jpg";
import UtilityNav from "./components/common/UtilityNav";
import NotFoundPage from "./components/common/NotFoundPage";
import NewNav from "./components/common/Nav";
import theme from "./theme";
import {
  ThemeProvider,
  CssBaseline,
  Box,
  CircularProgress,
} from "@mui/material";

// Home is the entry route. Lazy-loading it painted nav + footer first,
// then shoved the footer down when the chunk arrived, and that layout
// shift alone was a 0.355 CLS. Other routes stay lazy.
import Home from "./components/Home/Home";
const Rates = lazy(() => import("./components/Rates/Rates"));
const ContactPage = lazy(() => import("./components/Contact/ContactPage"));
const Insurance = lazy(() => import("./components/Insurance/Insurance"));
const Services = lazy(() => import("./components/Services/Services"));
const ConsultationForm = lazy(
  () => import("./components/Consultation/ConsultationForm")
);
const BlogPage = lazy(() => import("./components/Blog/BlogPage"));
const BlogPost = lazy(() => import("./components/Blog/BlogPost"));

const RouteFallback = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "50vh",
    }}
  >
    <CircularProgress sx={{ color: "secondary.main" }} />
  </Box>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        className="App"
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <ScrollToTop />
          <UtilityNav />
          <NewNav />
          <Breadcrumb backgroundImage={BreadCrumbImage} />
          <main style={{ flex: 1 }}>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/rates" element={<Rates />} />
                <Route path="/insurance" element={<Insurance />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/services/*" element={<Services />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPost />} />

                <Route
                  path="/request-consultation"
                  element={<ConsultationForm />}
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
